/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* communicate-service.ts  2025-08-12T13:43:44+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'krpc-base';

import type { UserLoc } from './wy-dto';

const _ = 'Communicate/';

export class CommunicateService {

  constructor(readonly r: RpcService) {}
  // 交换经纬度，1秒中调用一次即可,返回逗号分隔的经纬度 lng,lat；如果对方没开启共享，可以降低频率
  exchLngLat(d:UserLoc, m?: M): R<string>{
    return this.r.async(_ + 'exchLngLat', d, m);
  }
}
